import React from 'react';
import { Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import Currency from '../shared/Currency';

const FinancialTotals = ({ actualProfit, entity, estimatedLabor, proposedProfit, revenue }) => {
  switch (entity) {
    case 'purchaseOrders':
      return <HelpBlock className="text-center">Financial detail is not available for deliveries.</HelpBlock>;
    default:
      return (
        <Form horizontal>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={7}>
              Revenue
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                <Currency value={revenue} />
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={7}>
              Proposed Profit
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                <Currency value={proposedProfit} />
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={7}>
              Actual Profit
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                <Currency value={actualProfit} />
              </FormControl.Static>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={7}>
              Estimated Labor
            </Col>
            <Col sm={5}>
              <FormControl.Static>
                <Currency value={estimatedLabor} />
              </FormControl.Static>
            </Col>
          </FormGroup>
          <HelpBlock className="text-center">
            Only scheduled jobs are included in financial totals.
          </HelpBlock>
        </Form>
      );
  }
};

export default FinancialTotals;